import React, { Component } from 'react'
import { translate } from 'react-i18next'
import { func, object } from 'prop-types'
import { Link, withRouter } from 'react-router-dom'
import { SignUp } from '../../components/authentication/SignUp'
import { PagesPaths } from '../../constants/Pages'
import { initialization, stores, view } from '../../stores'
import { pushGtmTrigger } from '../../utilities/window'

class SignUpPageComponent extends Component {
  async componentDidMount () {
    const { history } = this.props
    await initialization
    if (stores.authentication.isAuthententicated()) {
      history.replace(PagesPaths.ACCOUNT.path)
    }
    pushGtmTrigger('sign_up')
  }

  async onRegistration () {
    const { history } = this.props
    await stores.account.getAccount()
    if (stores.location.redirection) {
      history.replace(stores.location.redirection)
    } else {
      history.replace(PagesPaths.ACCOUNT.path)
    }
  }

  render () {
    const { t } = this.props
    return (
      <div className='layout__container home__container--padding'>
        <div className='signin__container centered--container'>
          <div className='signin__title'>
            <h1>{t('common:signup:title')}</h1>
            <div className='flex-spacer' />
            <Link to={PagesPaths.SIGNIN.path}><button className='btn--small'>{t('common:signup:signin')}</button></Link>
          </div>
          <SignUp onRegistration={() => this.onRegistration()} />
        </div>
      </div>)
  }
}

SignUpPageComponent.propTypes = {
  t: func,
  history: object
}

export const SignUpPage = withRouter(translate()(view(SignUpPageComponent)))



// WEBPACK FOOTER //
// ./src/pages/authentification/SignUpPage.js